import Link from "next/link";

import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator } from "@/utils";

import styles from "./BootcampCard.module.scss";

interface BootcampCardProps {
  href: string;
  title: string;
  description: string;
  thumbnail: string;
  tags: string[];
  packData: {
    duration: string;
    currencySymbol: string;
    price: string;
    startDate: string;
  };
  styleData?: any;
}

const BootcampCard: React.FC<BootcampCardProps> = ({
  href,
  thumbnail,
  title,
  description,
  tags,
  packData,
  styleData,
}) => {
  const cls = classNameGenerator(styles);

  const { duration, currencySymbol, price, startDate } = packData || {};

  return (
    <Link href={href} className={cls("bootcampCard")}>
      <div
        className={cls("thumbnail")}
        style={{
          background: styleData?.backgroundColor,
        }}
      >
        <Image src={thumbnail} alt={title} />
        {startDate && (
          <Typography variant="paragraph1" className={cls("startDateChip")}>
            Starts From: {startDate}
          </Typography>
        )}
      </div>
      <div className={cls("content")}>
        {/* <Typography variant="paragraph1" className={cls("duration")}>
          {duration}
        </Typography> */}
        <Typography variant="heading3" className={cls("title")}>
          {title}
        </Typography>
        {currencySymbol && price!==null && <Typography
          variant="paragraph1"
          className={cls("price")}
          dangerouslySetInnerHTML={{
            __html: `<span>${currencySymbol}</span>${price}`,
          }}
        />}
        <Typography variant="paragraph1" className={cls("description")}>
          {description}
        </Typography>
      </div>
      <div className={cls("tags")}>
        {tags?.map((tag, index) => (
          <Typography
            key={index}
            variant="paragraph1"
            className={cls("tagChip")}
          >
            {tag}
          </Typography>
        ))}
      </div>
    </Link>
  );
};

export default BootcampCard;
